import { Observable } from "rxjs";
import NetworkService from "../network/networkService";
import { OdQueryParam } from "../enums";
import { helperFunctions } from "../helper";
import { IBrands, IBrandsAllResponse } from "../models/IBrands.model";
import { URLConfig } from "../network/urlStore";

export const getBrands = (
  queryParams?: Array<{
    key: OdQueryParam;
    value: string[];
  }>
): Observable<IBrandsAllResponse> => {
  let url = URLConfig.getBrandsTrialMasterURL();
  for (const param of queryParams || []) {
    url = helperFunctions.addQueryParam(url, param.key, param.value);
  }
  return new Observable((subscriber) => {
    NetworkService.get(url).then(
      (res: unknown) => {
        if (res) {
          const response = res as unknown as IBrandsAllResponse;
          subscriber.next(response);
        }
        subscriber.complete();
      },
      (error: Error) => {
        subscriber.error(error);
        console.log("Error while fetching user data", error);
      }
    );
  });
};

export const getBrandsNextPage = (
  nextPageURI: string
): Observable<IBrandsAllResponse> => {
  const url = URLConfig.getBrandsNextPageURl(nextPageURI);

  return new Observable((subscriber) => {
    NetworkService.get(url).then(
      (res) => {
        if (res) {
          const response = res as unknown as IBrandsAllResponse;
          subscriber.next(response);
        }
        subscriber.complete();
      },
      (error: any) => {
        subscriber.error(error);
        console.log("Error while fetching seasons master data", error);
      }
    );
  });
};

export const getAllBrands = (queryParams?: Array<{
    key: OdQueryParam;
    value: string[];
  }>) : Observable<IBrands[]>=> {
    let  allBrands: IBrands[] = []; 
    return new Observable((subscriber) => {
      const errorHandler = (error: any) => {
        subscriber.error(error);
      };

      const responseHandler = (response: IBrandsAllResponse) => {
        const brandsResponse = response;
        allBrands = [
          ...allBrands, 
          ...(brandsResponse.brands || []),
        ];

        if (brandsResponse.nextPageUri) {
          getBrandsNextPage(brandsResponse.nextPageUri).subscribe({
            next: responseHandler,
            error: errorHandler,
            complete: () => {
              console.info("Completed fetching all brands");
            },
          });
        } else {
          subscriber.next(allBrands);
          subscriber.complete();          }
      };

      getBrands(queryParams).subscribe({
        next: responseHandler,
        error: errorHandler,
        complete: () => {
          console.info("Completed fetching all brands");
        },
      });
    });
  };